// @flow
import React from 'react';
import {FormattedMessage} from 'react-intl';

type PickerLabelProps = {
    textClass?: string,
    messageId: string | null,
    defaultText: string
};

const PickerInputLabel = ({
    textClass = '',
    messageId,
    defaultText
}: PickerLabelProps) => {
    const message = messageId ? (
        <FormattedMessage id={messageId} defaultMessage={defaultText}>
            {/* istanbul ignore next */ (txt) => txt}
        </FormattedMessage>
    ) : (
        defaultText
    );

    return <span className={textClass}>{message}</span>;
};

export default PickerInputLabel;
